import Image from '@tiptap/extension-image';
import Youtube from '@tiptap/extension-youtube';
import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ResizableImageComponent from './ResizableImage';
import AlignableYoutubeComponent from './AlignableYoutube';
import GalleryBlockComponent from './GalleryBlock';

export const ResizableImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: { default: null, parseHTML: el => el.getAttribute('width') || el.style.width || null },
      height: { default: null, parseHTML: el => el.getAttribute('height') || el.style.height || null },
      align: { default: 'center', parseHTML: el => el.getAttribute('data-align') || 'center' },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ResizableImageComponent);
  },

  renderHTML({ HTMLAttributes }) {
    const align = HTMLAttributes.align || 'center';
    delete HTMLAttributes.align;

    const style = [];
    if (HTMLAttributes.width) style.push(`width: ${HTMLAttributes.width}`);
    if (HTMLAttributes.height) style.push(`height: ${HTMLAttributes.height}`);

    const wrapperStyle = {
      left: 'float: left; margin: 0 1.5rem 1rem 0; clear: left;',
      right: 'float: right; margin: 0 0 1rem 1.5rem; clear: right;',
      center: 'display: flex; justify-content: center; margin: 1.5rem 0; clear: both;',
      full: 'display: block; margin: 1.5rem 0; clear: both;',
    }[align] || '';

    return ['div', { style: wrapperStyle, 'data-align': align }, ['img', mergeAttributes(HTMLAttributes, { style: style.join('; ') })]];
  },
});

export const AlignableYoutube = Youtube.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      align: { default: 'center', parseHTML: el => el.getAttribute('data-align') || 'center' },
      width: { default: 640, parseHTML: el => parseInt(el.getAttribute('width')) || 640 },
      height: { default: 360, parseHTML: el => parseInt(el.getAttribute('height')) || 360 },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(AlignableYoutubeComponent);
  },
});

export const GalleryExtension = Node.create({
  name: 'gallery',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      images: { default: [] },
      columns: { default: 3 },
      gap: { default: 8 },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-gallery]' }];
  },

  renderHTML({ HTMLAttributes }) {
    const images = HTMLAttributes.images || [];
    const cols = HTMLAttributes.columns || 3;
    return ['div', {
      'data-gallery': '',
      style: `display: grid; grid-template-columns: repeat(${cols}, 1fr); gap: ${HTMLAttributes.gap || 8}px; margin: 1.5rem 0;`
    }, ...images.map(img => ['img', { src: img, style: 'width: 100%; height: auto; border-radius: 4px; object-fit: cover;' }])];
  },

  addNodeView() {
    return ReactNodeViewRenderer(GalleryBlockComponent);
  },
});
